import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  tokenExpiry: number | null;
  setTokens: (accessToken: string, expiresIn: number, refreshToken?: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      tokenExpiry: null,
      setTokens: (accessToken, expiresIn, refreshToken) => {
        set({
          accessToken,
          tokenExpiry: Date.now() + expiresIn * 1000,
          ...(refreshToken !== undefined ? { refreshToken } : {}),
        });
      },
      clearAuth: () => {
        set({ accessToken: null, refreshToken: null, tokenExpiry: null });
      },
    }),
    {
      name: 'demo:auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        tokenExpiry: state.tokenExpiry,
      }),
    },
  ),
);
